import { baseErrorHandler } from '@queries/baseErrorHandler';
import { $api } from '@service/RequestService';
import { useMutation } from 'react-query';

export function useChangeAutoConfig() {
  return useMutation(
    async (payload: object) => {
      const { data } = await $api.post('/v1/lead_client_auto_config', payload);

      return data;
    },
    {
      onError: baseErrorHandler
    }
  );
}
